import { render, staticRenderFns } from "./GateWalletManager1.vue?vue&type=template&id=c22e851c&scoped=true"
import script from "./GateWalletManager1.vue?vue&type=script&lang=js"
export * from "./GateWalletManager1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22e851c",
  null
  
)

export default component.exports